/**
 * @generated SignedSource<<91cd64aafe98dd4106c3d37cee856cc4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PaymentMethodType = "bankAccount" | "card" | "other" | "%future added value";
export type QuoteAddOn = "ACCESSORIES" | "SEVEN_DAY_PACKAGE" | "THREE_DAY_PACKAGE" | "%future added value";
export type TransactionType = "general" | "quoteBalance" | "surgeryBooking" | "%future added value";
export type PatientAuthQueryQuery$variables = {};
export type PatientAuthQueryQuery$data = {
  readonly myPatientDetails: {
    readonly dateOfBirth: any | null;
    readonly email: string;
    readonly emailConfirmed: boolean | null;
    readonly firstName: string | null;
    readonly id: string;
    readonly lastName: string | null;
    readonly phone: string | null;
    readonly quotes: ReadonlyArray<{
      readonly activeFinalPrice: number | null;
      readonly activeInvoice: string | null;
      readonly addOns: ReadonlyArray<QuoteAddOn> | null;
      readonly age: number | null;
      readonly contracts: ReadonlyArray<{
        readonly contract: {
          readonly id: string;
          readonly name: string;
        };
        readonly id: string;
        readonly storedContractKey: string;
      }> | null;
      readonly createdAt: string;
      readonly email: string;
      readonly fileList: ReadonlyArray<{
        readonly response: {
          readonly url: string;
        };
      }> | null;
      readonly hasMedicalConditions: boolean | null;
      readonly heightFt: number | null;
      readonly heightIn: number | null;
      readonly id: string;
      readonly invoice: ReadonlyArray<{
        readonly addon: {
          readonly id: string;
          readonly name: string;
        } | null;
        readonly itemType: string;
        readonly procedure: {
          readonly name: string;
        } | null;
      }> | null;
      readonly labsRequested: {
        readonly createdAt: string;
        readonly id: string;
        readonly labsOrderPDF: string | null;
      } | null;
      readonly lastName: string | null;
      readonly lost50pounds: boolean | null;
      readonly maxQuoted: number | null;
      readonly medicalConditions: ReadonlyArray<string> | null;
      readonly minQuoted: number | null;
      readonly name: string;
      readonly otherMedicalConditionDescription: string | null;
      readonly phone: string;
      readonly priorCosmeticSurgery: boolean | null;
      readonly priorCosmeticSurgeryDescription: string | null;
      readonly procedureDescription: string | null;
      readonly selectedLocation: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly selectedProceduresV2: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }> | null;
      readonly selectedSurgeon: {
        readonly id: string;
        readonly image: string;
        readonly name: string;
      } | null;
      readonly smoker: boolean | null;
      readonly status: {
        readonly color: string | null;
        readonly id: string;
        readonly name: string;
        readonly position: number | null;
      } | null;
      readonly surgeryBooking: {
        readonly createdAt: string;
        readonly id: string;
        readonly surgeryDate: string;
        readonly updatedAt: string;
      } | null;
      readonly tasksCompleted: ReadonlyArray<{
        readonly createdAt: string;
        readonly id: string;
        readonly task: {
          readonly actionRequired: string | null;
          readonly createdAt: string | null;
          readonly icon: string | null;
          readonly id: string;
          readonly position: number | null;
          readonly task: string;
        };
      }> | null;
      readonly updatedAt: string;
      readonly weight: number | null;
      readonly zipCode: string;
    }> | null;
    readonly transactions: ReadonlyArray<{
      readonly id: string;
      readonly paymentAmount: number;
      readonly paymentMethodType: PaymentMethodType | null;
      readonly quote: {
        readonly id: string;
      } | null;
      readonly transactionType: TransactionType | null;
    } | null> | null;
    readonly zipCode: string | null;
  } | null;
};
export type PatientAuthQueryQuery = {
  response: PatientAuthQueryQuery$data;
  variables: PatientAuthQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Transaction",
  "kind": "LinkedField",
  "name": "transactions",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentMethodType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Quote",
      "kind": "LinkedField",
      "name": "quote",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateOfBirth",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailConfirmed",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "age",
  "storageKey": null
},
v13 = [
  (v0/*: any*/),
  (v11/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessLocation",
  "kind": "LinkedField",
  "name": "selectedLocation",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Surgeon",
  "kind": "LinkedField",
  "name": "selectedSurgeon",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Procedure",
  "kind": "LinkedField",
  "name": "selectedProceduresV2",
  "plural": true,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "heightFt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "heightIn",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "fileList",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FileResponse",
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smoker",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasMedicalConditions",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medicalConditions",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherMedicalConditionDescription",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lost50pounds",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priorCosmeticSurgery",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priorCosmeticSurgeryDescription",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "procedureDescription",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addOns",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeInvoice",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "PatientContract",
  "kind": "LinkedField",
  "name": "contracts",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storedContractKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContractTemplate",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": (v13/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemType",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Addon",
  "kind": "LinkedField",
  "name": "addon",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeFinalPrice",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxQuoted",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minQuoted",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Status",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v11/*: any*/),
    (v37/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "SurgeryBooking",
  "kind": "LinkedField",
  "name": "surgeryBooking",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surgeryDate",
      "storageKey": null
    },
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "CompletedTask",
  "kind": "LinkedField",
  "name": "tasksCompleted",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "task",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actionRequired",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        },
        (v37/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "LabsRequest",
  "kind": "LinkedField",
  "name": "labsRequested",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "labsOrderPDF",
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PatientAuthQueryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "myPatientDetails",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Quote",
            "kind": "LinkedField",
            "name": "quotes",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v3/*: any*/),
              (v12/*: any*/),
              (v7/*: any*/),
              (v6/*: any*/),
              (v4/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "QuoteInvoiceItem",
                "kind": "LinkedField",
                "name": "invoice",
                "plural": true,
                "selections": [
                  (v32/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Procedure",
                    "kind": "LinkedField",
                    "name": "procedure",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PatientAuthQueryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "myPatientDetails",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Quote",
            "kind": "LinkedField",
            "name": "quotes",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v3/*: any*/),
              (v12/*: any*/),
              (v7/*: any*/),
              (v6/*: any*/),
              (v4/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "QuoteInvoiceItem",
                "kind": "LinkedField",
                "name": "invoice",
                "plural": true,
                "selections": [
                  (v32/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Procedure",
                    "kind": "LinkedField",
                    "name": "procedure",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e75e138cd3c5154c37a268ffda3c21e5",
    "id": null,
    "metadata": {},
    "name": "PatientAuthQueryQuery",
    "operationKind": "query",
    "text": "query PatientAuthQueryQuery {\n  myPatientDetails {\n    transactions {\n      id\n      paymentAmount\n      paymentMethodType\n      transactionType\n      quote {\n        id\n      }\n    }\n    id\n    firstName\n    lastName\n    zipCode\n    dateOfBirth\n    phone\n    email\n    emailConfirmed\n    quotes {\n      id\n      createdAt\n      updatedAt\n      name\n      lastName\n      age\n      email\n      phone\n      zipCode\n      selectedLocation {\n        id\n        name\n      }\n      selectedSurgeon {\n        id\n        name\n        image\n      }\n      selectedProceduresV2 {\n        id\n        name\n      }\n      heightFt\n      heightIn\n      weight\n      fileList {\n        response {\n          url\n        }\n      }\n      smoker\n      hasMedicalConditions\n      medicalConditions\n      otherMedicalConditionDescription\n      lost50pounds\n      priorCosmeticSurgery\n      priorCosmeticSurgeryDescription\n      procedureDescription\n      addOns\n      activeInvoice\n      contracts {\n        id\n        storedContractKey\n        contract {\n          id\n          name\n        }\n      }\n      invoice {\n        itemType\n        addon {\n          id\n          name\n        }\n        procedure {\n          name\n          id\n        }\n        id\n      }\n      activeFinalPrice\n      maxQuoted\n      minQuoted\n      status {\n        id\n        name\n        position\n        color\n      }\n      surgeryBooking {\n        id\n        surgeryDate\n        createdAt\n        updatedAt\n      }\n      tasksCompleted {\n        id\n        createdAt\n        task {\n          id\n          task\n          actionRequired\n          icon\n          position\n          createdAt\n        }\n      }\n      labsRequested {\n        id\n        labsOrderPDF\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9c1d29ba6fd2186096899fd5fef194e";

export default node;
